
import api from '../../../services/api';

const firmService = {
  // Get firms. Distributors receive only their own firm from the backend.
  async getFirms(params = {}) {
    const response = await api.get('/firms', { params });
    const result = response.data?.data;

    return {
      firms: Array.isArray(result?.firms)
        ? result.firms
        : Array.isArray(result?.data)
          ? result.data
          : [],
      pagination: result?.pagination ?? response.data?.pagination ?? null,
    };
  },

  // Get a single firm by ID.
  async getFirmById(firmId) {
    if (firmId === undefined || firmId === null || firmId === '') {
      throw new Error('Firm ID is required.');
    }

    const response = await api.get(
      `/firms/${encodeURIComponent(firmId)}`
    );

    const result = response.data?.data;

    return result?.firm ?? result ?? null;
  },

  // Create a new firm. Backend authorization remains authoritative.
  async createFirm(firmData) {
    const response = await api.post('/firms', firmData);
    const result = response.data?.data;

    return result?.firm ?? result ?? null;
  },

  // Update firm details.
  async updateFirm(firmId, firmData) {
    const response = await api.patch(
      `/firms/${encodeURIComponent(firmId)}`,
      firmData
    );

    const result = response.data?.data;

    return result?.firm ?? result ?? null;
  },

  // Activate or deactivate a firm.
  async updateFirmStatus(firmId, status) {
    const response = await api.patch(
      `/firms/${encodeURIComponent(firmId)}/status`,
      { status }
    );

    const result = response.data?.data;

    return result?.firm ?? result ?? null;
  },
};

export default firmService;
